import OfferingItem from "./OfferingItem"
import "./Offerings.css"

// Import offering images
import stemImage from "../assets/Stem.png"
import summerCampImage from "../assets/SummerCamp.png"
import winterCampImage from "../assets/WinterCamp.png"
import competitionImage from "../assets/Competition.png"
import kidsSchoolImage from "../assets/KidsSchool.png"
import kahootAppImage from "../assets/KahootApp.png"
import tuitionImage from "../assets/tuition.png"

const Offerings = () => {
  const offeringData = [
    {
      image: stemImage,
      title: "STEM COURSES",
      description:
        "Hands-on learning in Science, Technology, Engineering, and Math to develop problem-solving and innovation skills.",
      link: "/life-skill-courses",
    },
    {
      image: summerCampImage,
      title: "SUMMER CAMP AND COURSES",
      description:
        "Fun seasonal programs combining learning with interactive activities to boost creativity and critical thinking.",
      link: "/summer-camp",
    },
    {
      image: winterCampImage,
      title: "WINTER CAMP AND COURSES",
      description: "Skill-building winter programs with creative projects and hands-on learning.",
      link: "/winter-camp",
    },
    {
      image: competitionImage,
      title: "COMPETITIONS",
      description: "Exciting challenges and contests to encourage creativity, teamwork, and academic excellence.",
      link: "/competitions",
    },
    {
      image: kidsSchoolImage,
      title: "POLYMATH-KIDS @SCHOOLS",
      description:
        "Partnering with schools to integrate 21st-century skills into their curriculum through structured learning programs.",
      link: "/polymath-kids-schools",
    },
    {
      image: kahootAppImage,
      title: "KAHOOT-LIKE APP",
      description: "A fun and interactive quiz-based learning platform to make education engaging and effective.",
      link: "/kahoot-app",
    },
    {
      image: tuitionImage,
      title: "TUITIONS",
      description:
        "Personalized one-on-one and group tutoring sessions in various subjects to enhance academic performance.",
      link: "/tuitions",
    },
  ]

  return (
    <section className="offerings-section">
      <div className="container">
        <h2 className="offerings-title">
          Polymath-Kids <span>Offerings</span>
        </h2>

        <div className="offerings-grid">
          {offeringData.map((offering, index) => (
            <OfferingItem
              key={index}
              title={offering.title}
              description={offering.description}
              image={offering.image}
              link={offering.link}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Offerings